export const faqs_data_referers = [
  {
    question: '¿Cómo funciona el programa de referidos?',
    answer: (
      <>
        Nuestro programa de referidos permite que todos nuestros alumnos activos puedan
        invitar a sus amigos a estudiar en Crack The Code y obtener beneficios. Solo debes
        generar y compartir tu enlace personalizado con tus amigos para que ellos puedan
        acceder a un descuento de 25% sobre el precio de venta. Por cada amigo que se
        matricule exitosamente en algún curso o ruta de Crack The Code, recibirás un
        Giftcard de Amazon de US $25.{' '}
      </>
    )
  },
  {
    question: '¿A quién puedo invitar para obtener mi recompensa?',
    answer: (
      <>
        Para recibir el Giftcard de Amazon de US $25, debes invitar a amigos y familiares
        que nunca antes hayan estudiado en Crack The Code.{' '}
      </>
    )
  },
  {
    question: '¿Qué condiciones se deben cumplir para que yo gane la recompensa?',
    answer: (
      <>
        Para que accedas a la giftcard, tu invitado deberá matricularse exitosamente en un
        curso o ruta de Crack The Code usando tu enlace personalizado de descuento. Una
        vez que hayamos verificado la inscripción, te enviaremos por correo electrónico el
        acceso al Giftcard. Tu invitado tendrá una semana para realizar cualquier cambio o
        anular su inscripción. Una vez culminado este plazo, si no se anula la
        inscripción, la matrícula será considerada exitosa y recibirás el giftcard.{' '}
      </>
    )
  },
  {
    question: '¿Cómo y cuándo recibiré el giftcard?',
    answer: (
      <>
        Te enviaremos por correo electrónico cuando confirmemos la matrícula exitosa de tu
        invitado. Este plazo no será mayor a 10 días calendario después de su matrícula.{' '}
      </>
    )
  }
];

export const faqs_data_course = [
  {
    question: '¿Cómo son nuestros cursos y rutas de programación online para niños?',
    answer: (
      <>
        Nuestros cursos y rutas de programación cuentan se dictan a través de clases en
        línea y en vivo. Los estudiantes y profesores se conectan por medio de la
        plataforma Zoom. Esto permite que los niñ@s puedan intervenir en vivo, realizar
        preguntas y compartir con sus profesores y compañeros en clase. Nuestros grupos
        son de máximo 6 estudiantes con edades e intereses similares, que quedan a cargo
        de profesores expertos en tecnología con formación pedagógica. Los estudiantes
        aplican todo lo aprendido en sus proyectos finales. Entre estos pueden hacer
        videojuegos, páginas web, proyectos de inteligencia artificial y muchos más.{' '}
      </>
    )
  },
  {
    question: '¿Por qué elegirnos como academia de programación para tus hij@s?',
    answer: (
      <>
        Porque nuestros docentes expertos aplican una metodología que sacará lo mejor del
        talento digital de tu hij@. A través del Thinking Based Learning, buscamos que los
        estudiantes sean protagonistas de su propio aprendizaje y puedan encontrar
        posibles soluciones haciendo uso de su capacidad crítica y creativa. Promovemos
        una evaluación formativa en donde, módulo a módulo, ayudamos a las niñas y niños a
        potenciar sus habilidades tecnológicas.{' '}
      </>
    )
  },
  {
    question: '¿Por qué es importante para los niños aprender a programar?',
    answer: (
      <>
        Con todos los dispositivos y aplicaciones que utilizamos, la tecnología se ha
        vuelto una parte esencial de los diferentes ámbitos de la vida cotidiana. Es por
        eso que la programación se considera como el lenguaje del futuro, ya que se está
        volviendo necesaria para casi todas las áreas del conocimiento y el desarrollo.
        ¡Tu hij@ puede contar con grandes oportunidades en su futuro profesional si
        aprende programación!{' '}
      </>
    )
  },
  {
    question: '¿Qué aprenderán tus niños durante nuestras clases de programación online?',
    answer: (
      <>
        En nuestras clases de programación online, dependiendo de su rango de edad y del
        curso elegido, tu hij@ aprenderá habilidades que desarrollen su pensamiento
        computacional y su razonamiento lógico. De esta manera, pasará a realizar
        actividades de programación que le ayudarán a crear bots de programas, videojuegos
        retro, algoritmos, entre otras cosas para las que echará a volar su talento, su
        imaginación y aprendizajes.
      </>
    )
  },
  {
    question: '¿Cuáles son los planes de pago para nuestras clases?',
    answer: (
      <>
        Contamos con el plan de pago de ruta completa o pago total, donde con un solo pago
        y precio especial, podrás disfrutar de meses de diversión y aprendizaje. Contamos
        también con el pago por el primer curso de la ruta, luego de terminado el curso,
        se deberá pagar por cada curso, uno a uno progresivamente.
      </>
    )
  }
];

export const faqs_data = [
  {
    question: '¿Qué es una ruta de aprendizaje?',
    answer: (
      <>
        Una ruta de aprendizaje es un conjunto ordenado de cursos en los que tu hij@ puede
        aprender a detalle una habilidad tech. Contamos con rutas de aprendizaje para
        habilidades como programación, diseño gráfico, generación de contenido, desarrollo
        de videojuegos, entre otras.
      </>
    )
  },
  {
    question: '¿Cómo son nuestras rutas de programación y tecnología para niños?',
    answer: (
      <>
        Nuestras rutas de aprendizaje tienen una duración de entre 9 y 10.5 meses. Dentro
        de ese tiempo se desarrollan los cursos de manera semanal y el aprendizaje de tu
        hij@ avanza de manera progresiva. Cada curso cuenta con un proyecto final en el
        que tu coder pondrá a prueba todo lo aprendido.
      </>
    )
  },
  {
    question: '¿Por qué inscribirse a una ruta de aprendizaje?',
    answer: (
      <>
        Porque es la mejor manera de enseñar a tu hij@ diversas habilidades que pueden
        perfilarlo para un muy exitoso futuro en la industria de la tecnología.
      </>
    )
  },
  {
    question: '¿Qué se aprende en nuestras rutas de programación y tecnología?',
    answer: (
      <>
        Tu hij@ puede aprender a detalle habilidades tech como programación, desarrollo de
        videojuegos, edición de videos, diseño gráfico, entre otras.
      </>
    )
  }
];

export const faqs_data_mx = [
  {
    question: '¿Cómo son nuestros cursos y rutas de programación online para niños?',
    answer: (
      <>
        Nuestros cursos y rutas de programación se dictan a través de clases en línea y en
        vivo. Los estudiantes y profesores se conectan por medio de la plataforma Zoom.
        Esto les permite intervenir en vivo, realizar preguntas y compartir con sus
        profesores y compañeros en clase. Nuestras clases son altamente personalizadas,
        con grupos de máximo 6 estudiantes de edades e intereses similares, quienes quedan
        a cargo de profesores expertos en tecnología con formación pedagógica. Los
        estudiantes aplican todo lo aprendido en sus proyectos finales. Entre estos pueden
        hacer videojuegos, páginas web, proyectos de inteligencia artificial y muchos más.
      </>
    )
  },
  {
    question: '¿Por qué elegirnos cómo academia de programación para niños en México?',
    answer: (
      <>
        Crack the Code es la mejor opción para tomar clases de programación en México
        porque contamos con una amplia experiencia internacional. Nuestra metodología
        sacará lo mejor del talento digital de cualquier niño en México. A través del
        Thinking Based Learning, buscamos que los estudiantes sean protagonistas de su
        propio aprendizaje y puedan encontrar posibles soluciones haciendo uso de su
        capacidad crítica y creativa. Promovemos una evaluación formativa en donde, módulo
        a módulo, ayudamos a las niñas y niños a potenciar sus habilidades tecnológicas.
      </>
    )
  },
  {
    question: '¿Qué aprenderán tus niños durante nuestras clases de programación online?',
    answer: (
      <>
        En nuestras clases de programación online en México, dependiendo de su rango de
        edad y del curso elegido, tu hij@ aprenderá habilidades que desarrollen su
        pensamiento computacional y su razonamiento lógico. De esta manera, pasará a
        realizar actividades de programación durante nuestros cursos que le ayudarán a
        crear bots de programas, videojuegos retro, algoritmos, entre otras cosas. Tu hijo
        echará a volar su talento, su imaginación y aprendizajes.
      </>
    )
  },
  {
    question: '¿Cómo financiar un curso de programación para niños en México?',
    answer: (
      <>
        Contamos con el plan de pago de ruta completa o pago total, donde con un solo pago
        y precio especial, podrás disfrutar de meses de diversión y aprendizaje. Contamos
        también con el pago por el primer curso de la ruta, luego de terminado el curso,
        se deberá pagar por cada curso, uno a uno progresivamente. Asimismo, contamos con
        el plan de pago mensual o suscripción a un precio especial. Este pago se debitará
        mes a mes automáticamente por 9 meses.
      </>
    )
  }
];

export const faqs_data_col = [
  {
    question: '¿Cómo son nuestros cursos de programación para niños en Colombia?',
    answer: (
      <>
        Dictamos nuestros cursos y rutas con clases online en tiempo real a través de la
        plataforma Zoom. De esta manera, nuestros coders pueden participar e interactuar
        con sus profesores y compañeros. Los programas que ofrecemos tienen un alto nivel
        de personalización, ya que cada clase recibe a un máximo de 6 estudiantes. Todo lo
        que enseñamos es aplicado por ellos en los proyectos finales de cada curso, donde
        pueden crear cosas increíbles del mundo tech.
      </>
    )
  },
  {
    question: '¿Por qué elegirnos cómo academia de programación para niños en Colombia?',
    answer: (
      <>
        Ofrecemos la mejor alternativa en educación digital para niños de Colombia y de
        todo Latinoamérica. El talento tech de nuestros estudiantes se potencia con
        nuestra metodología Thinking Based Learning, la cual promueve su creatividad,
        autonomía y sentido crítico. ¡Todo esto bajo dinámicas y proyectos muy divertidos
        de programación, tecnología y creatividad para niños!
      </>
    )
  },
  {
    question:
      ' ¿Qué les enseñaremos a tus niños durante nuestros cursos de programación online para Colombia?',
    answer: (
      <>
        Según el curso de programación para niños elegido y la edad para el mismo, tu hij@
        desarrollará cualidades tech como el pensamiento computacional y podrá crear
        programas, videojuegos y aplicaciones. Estas habilidades le darán sus primeros
        pasos para un futuro lleno de éxitos en la industria de la tecnología.
      </>
    )
  },
  {
    question: ' ¿Cómo financiar un curso de programación para niños en Colombia?',
    answer: (
      <>
        Ofrecemos una ruta completa o un plan de pago completo con el que tu pequeño
        asegurará varios meses de diversión y educación por un precio reducido. También
        aceptamos pagos para el primer curso de la ruta, pero los padres deben considerar
        que, después de completar ese curso, tendrán que pagar progresivamente por cada
        programa adicional. Podemos ofrecer un precio reducido en un plan de pago mensual
        o suscripción. Durante nueve meses, este dinero se deducirá automáticamente cada
        mes.
      </>
    )
  }
];
